<div class="container my-5">
    <h3 class="text-center">Holiday Calendar 2026</h3>

  <div class="holiday-wrapper mt-5">
    <div class="table-responsive">
      <table class="table holiday-table mb-0">
        <thead>
          <tr>
            <th>Month</th>
            <th>Date</th>
            <th>Day</th>
            <th>Holiday Name</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let h of holidays2026">
            <td>{{ h.month }}</td>
            <td>{{ h.date }}</td>
            <td>{{ h.day }}</td>
            <td>{{ h.holiday }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

</div>
